// LivestreamIndex.jsx
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Redirect from '../container/Redirect.js';

import { loadingIconOpacity } from '../style/variables.js';

import LoadingIconResource from '../../img/img-loading-grey-20.svg';

export class LivestreamIndex extends React.PureComponent {
  pendingFetch = null;
  fetchFeeds = () => {
    const {
      index,
      isRemoteConfigMerged,
      intersectedFeedName,
      feedNameWithQuery,
      renewFeedId,
      latestFeedRenewUnix,
      fetchFeeds,
    } = this.props;
    if (intersectedFeedName) {
      if (isRemoteConfigMerged) {
        fetchFeeds({
          id: renewFeedId,
          type: feedNameWithQuery,
          page: 1,
          limit: Math.max(10, index),
          unixTimestamp: latestFeedRenewUnix,
        });
      } else {
        this.pendingFetch = () =>
          fetchFeeds({
            id: renewFeedId,
            type: feedNameWithQuery,
            page: 1,
            limit: Math.max(10, index),
            unixTimestamp: latestFeedRenewUnix,
          });
      }
    }
  };
  componentDidMount() {
    this.fetchFeeds();
  }
  componentDidUpdate(prevProps) {
    const { isAuthed, isRemoteConfigMerged, feedNameWithQuery } = this.props;
    if (
      isAuthed !== prevProps.isAuthed ||
      isRemoteConfigMerged !== prevProps.isRemoteConfigMerged ||
      feedNameWithQuery !== prevProps.feedNameWithQuery
    ) {
      if (feedNameWithQuery !== prevProps.feedNameWithQuery) {
        this.fetchFeeds();
      } else if (this.pendingFetch) {
        this.pendingFetch();
        this.pendingFetch = null;
      }
    }
  }
  componentWillUnmount() {
    clearInterval(this.intervalId);
  }
  renderLoading = () => {
    return (
      <LoadingWrapper>
        <LoadingIcon src={LoadingIconResource} alt="loading icon" />
      </LoadingWrapper>
    );
  };

  render() {
    const { index, userIds } = this.props;
    // TODO: handle index larger than online creators count
    return userIds?.[index] ? (
      <Redirect to={`/user/${userIds[index]}/livestream`} />
    ) : (
      this.renderLoading()
    );
  }
}

LivestreamIndex.propTypes = {
  index: PropTypes.number,
  isAuthed: PropTypes.bool,
  isRemoteConfigMerged: PropTypes.bool,
  feedNameWithQuery: PropTypes.string,
  intersectedFeedName: PropTypes.string,
  renewFeedId: PropTypes.string,
  latestFeedRenewUnix: PropTypes.number,
  userIds: PropTypes.array,
  fetchFeeds: PropTypes.func,
};

LivestreamIndex.defaultProps = {
  index: 0,
  isAuthed: false,
  isRemoteConfigMerged: false,
  feedNameWithQuery: null,
  intersectedFeedName: null,
  renewFeedId: null,
  latestFeedRenewUnix: null,
  sorts: [],
  fetchFeeds: () => null,
};

const LoadingWrapper = styled.div`
  padding-top: 50px;
  display: flex;
  justify-content: center;
  opacity: ${loadingIconOpacity};
`;

const LoadingIcon = styled.img`
  width: 32px;
  height: auto;
`;

export default LivestreamIndex;
